import { FetchError } from "../errors/FetchError";
import { fetchWithAuthorization, fetchApiImageAuth2 } from "./fetch";

export const createArea = async (selectedCondominium, formData) => {
    try {
        const data = await fetchApiImageAuth2(`/commonArea/${selectedCondominium}`, formData, 'POST');
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to Create bank failed");
    }
}

export const getCommonAreas = async (page, limit = 5, condominium) => {
    try {
        let url = `/commonArea?page=${page}&limit=${limit}`
        if (condominium) url += `&condominium=${condominium}`
        const data = await fetchWithAuthorization(url);
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to get common areas failed");
    }
}

export const deleteArea = async (id) => {
    try {
        const data = await fetchWithAuthorization(`/commonArea/${id}`, null, 'DELETE');
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to remove common areas failed");
    }
}

export const getReservations = async (params, signal) => {
    const { me, start_at, end_at, status, commonArea } = params;
    try {
        let url = `/commonArea/reservation/${commonArea}?limit=40`;
        if (start_at && end_at) url += `&start_at=${start_at}&end_at=${end_at}`;
        if (me) url += `&me=1`;
        if (status) url += `&status=${status}`
        const data = await fetchWithAuthorization(url, signal);
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to get reservations failed");
    }
}

export const getReservationDetails = async (reservation) => {
    try {
        const data = await fetchWithAuthorization(`/commonArea/reservation/details/${reservation}`);
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to get reservations failed");
    }
}

export const createReservation = async (commonArea, obj) => {
    try {
        const data = await fetchApiImageAuth2(`/commonArea/reservation/${commonArea}`, obj, 'POST');
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to get reservations failed");
    }
}

export const updateArea = async (id, formData) => {
    try {
        const data = await fetchApiImageAuth2(`/commonArea/update/${id}`, formData, 'POST');
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to Updating area failed");
    }
}


export const setUpdateStatusReservation = async (id, status) => {
    try {
        const data = await fetchWithAuthorization(`/commonArea/reservation/${id}`, { status: status }, 'PUT');
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to Updating reservation failed");
    }
}